import React, {PropTypes} from 'react';
import {connect} from 'react-redux';


// import * as commonActionCreators from '../../../actions/common';
let allActionCreators = Object.assign({});

class EducationStyle extends React.Component {

	static propTypes = {
    location: PropTypes.object
  };

  static contextTypes = {
    store: PropTypes.any,
    router: React.PropTypes.object.isRequired
  };

	constructor(props) {
		super(props);
		this.state = {}
	}

	componentDidMount() {
    document.title = 'Diamonds Direct - Education';
    document.getElementsByTagName("META")[7].content="Shop our extensive selection of diamond engagement rings, wedding bands, and other jewelry online. See the Diamonds Direct Difference today!";
  }

  newTabNav(page) {
  	let win = window.open(page, '_blank');
    win.focus();
  }

  externalNav(page) {
    window.location.href = '/' + page;
  }

  internalNav(page) {
  	this.context.router.push('/' + page);
  }

  openIntercom() {
    acquireIO.max();
  }

  openNew(page) {
    let win = window.open(page, '_blank');
    win.focus();
  }

	render() {
		return <div className={'EducationStyle EducationPage'}>
      <div className={'eduHeader'}>Engagement Ring Styles</div>
      <div className='eduBody'>
        <div className='eduStyleHeaderSection'></div>
        <div className='eduStylesWrapper'>
          <div className='esInnerWrapper'>
            <div className='esItem'>
              <div className='esiImgWrapper'>
                <img src='https://ddw2.diamondsdirect.com/img/education/ring/web/solitaire.png' />
              </div>
              <div className='esiBoxWrapper'>
                <div className='esiBoxInnerWrapper'>
                  <div className='esbTitle'>Solitaire</div>
                  <div className='esbBr'>
                    <img src='https://ddw2.diamondsdirect.com/img/education/ring/web/iconline.svg' />
                  </div>
                  <div className='esbP'>Of the prong settings, the most common is the solitaire setting featuring one diamond. The solitaire setting draws all of our attention to the stone with little to distract us like other stones or fancy metalwork.</div>
                  <div className='esbLink' onClick={() => this.internalNav('gallery/engagement-rings?mode=setting&settingtype=solitaire&style=contemporary,vintage,classic')}>Shop Solitaire Rings &gt;</div>
                </div>
              </div>     
            </div>
            <div className='esItem'>
              <div className='esiImgWrapper'>
                <img src='https://ddw2.diamondsdirect.com/img/education/ring/web/threestone.png' />
              </div>
              <div className='esiBoxWrapper'>
                <div className='esiBoxInnerWrapper'>
                  <div className='esbTitle'>Three-Stone</div>
                  <div className='esbBr'>
                    <img src='https://ddw2.diamondsdirect.com/img/education/ring/web/iconline.svg' />
                  </div>
                  <div className='esbP'>The three-stone setting is a versatile setting that can be used for engagement, anniversary, or any occasion. The three stones, set closely together, are said to symbolize the couple’s past, present, and future.</div>
                  <div className='esbLink' onClick={() => this.internalNav('gallery/engagement-rings?mode=setting&settingtype=threestone&style=contemporary,vintage,classic')}>Shop Three-Stone Rings &gt;</div>
                </div>
              </div>     
            </div>
            <div className='esItem'>
              <div className='esiImgWrapper'>
                <img src='https://ddw2.diamondsdirect.com/img/education/ring/web/halo.png' />
              </div>
              <div className='esiBoxWrapper'>
                <div className='esiBoxInnerWrapper'>
                  <div className='esbTitle'>Halo</div>
                  <div className='esbBr'>
                    <img src='https://ddw2.diamondsdirect.com/img/education/ring/web/iconline.svg' />
                  </div>
                  <div className='esbP'>The halo setting refers to the placement of diamonds or other gemstones in a concentric circle or square around a center stone. The halo setting makes the center stone appear larger—a great option to boost the appearance of any center stone—and it increases the overall sparkle of the ring.</div>
                  <div className='esbLink' onClick={() => this.internalNav('gallery/engagement-rings?mode=setting&settingtype=halo&style=contemporary,vintage,classic')}>Shop Halo Rings &gt;</div>
                </div>
              </div>     
            </div>
            <div className='esItem'>
              <div className='esiImgWrapper'>
                <img src='https://ddw2.diamondsdirect.com/img/education/ring/web/pave.png' />
              </div>
              <div className='esiBoxWrapper'>
                <div className='esiBoxInnerWrapper'>
                  <div className='esbTitle'>Pavé</div>
                  <div className='esbBr'>
                    <img src='https://ddw2.diamondsdirect.com/img/education/ring/web/iconline.svg' />
                  </div>
                  <div className='esbP'>The pavé setting, pronounced "pa-vay", comes from the French word "to pave", as in paved with diamonds. By closely setting small diamonds together with minimal visibility of the tiny metal beads or prongs holding the stones in place, the effect is one of continuous sparkle.</div>
                  <div className='esbLink' onClick={() => this.internalNav('gallery/engagement-rings?mode=setting&settingtype=pave&style=contemporary,vintage,classic')}>Shop Pavé Rings &gt;</div>
                </div>
              </div>     
            </div>
            <div className='esItem'>
              <div className='esiImgWrapper'>
                <img src='https://ddw2.diamondsdirect.com/img/education/ring/web/channel.png' />
              </div>
              <div className='esiBoxWrapper'>
                <div className='esiBoxInnerWrapper'>
                  <div className='esbTitle'>Channel</div>
                  <div className='esbBr'>
                    <img src='https://ddw2.diamondsdirect.com/img/education/ring/web/iconline.svg' />
                  </div>
                  <div className='esbP'>The channel setting is a secure way to set smaller diamonds in a row into the band of the ring, making a metal channel of sparkling stones flush with the shank. Since there are no prongs, this setting is also a good option for a snag-free and secure design.</div>
                  <div className='esbLink' onClick={() => this.internalNav('gallery/engagement-rings?mode=setting&settingtype=pave&style=contemporary')}>Shop Channel Rings &gt;</div>
                </div>
              </div>     
            </div>
            <div className='esItem'>
              <div className='esiImgWrapper'>
                <img src='https://ddw2.diamondsdirect.com/img/education/ring/web/sharedprong1.png' />
              </div>
              <div className='esiBoxWrapper'>
                <div className='esiBoxInnerWrapper'>
                  <div className='esbTitle'>Shared Prong</div>
                  <div className='esbBr'>
                    <img src='https://ddw2.diamondsdirect.com/img/education/ring/web/iconline.svg' />
                  </div>
                  <div className='esbP'>A sophisticated look, the shared prong engagement ring is distinguished by the diamonds in the mounting set into prongs shared by the neighboring diamond. This look allows for fewer prongs and less metal covering each diamond, permitting more light return and sparkle.</div>
                  <div className='esbLink' onClick={() => this.internalNav('gallery/engagement-rings?mode=setting&settingtype=solitaire,halo,pave,threestone&style=contemporary')}>Shop Shared Prong Rings &gt;</div>
                </div>
              </div>     
            </div>
          </div>
        </div>
        <div className='eduStyleFooterSection'></div>
      </div>
		</div>;
	}
}
export default EducationStyle;

function mapStateToProps(state) {
  return {

  };
}

export const EducationStyleContainer = connect(
  mapStateToProps,
  allActionCreators
)(EducationStyle);


// WEBPACK FOOTER //
// ./src/components/views/education/EducationStyle.jsx